module.exports = __webpack_public_path__ + "img/pt.53539e9e.png";